import $ from "jquery";
import { LocalStorage } from "storage-manager-js";
import { localStorage } from "./__constant";
import { encode } from "js-base64";
import __popupData from "./__popup-data";
import ajaxGetWcPrice from "../../utils/libraries/ajax-get-wc-price";
import handleSendPostData from "../../utils/handle-send-post-data";
import __listProductsCustomizer2 from "./__list-products-customizer-2";
import ajaxSaveWishlist from "../../utils/libraries/ajax.save-wishlist";

const formRequest = () => {
  const init = () => {
    handleData();
  };

  const handleButtonResult = (
    productListsEliminate,
    resultUrlSelector,
    storeData
  ) => {
    if ($(resultUrlSelector).length === 0) return;
    const hrefResultObj = {
      id: $(resultUrlSelector).data("term_id"),
      productIds: productListsEliminate.map((p) => p.product_id),
      color: storeData["kleur-kleur"]
        ? storeData["kleur-kleur"]["customizer-option"]
        : null,
    };

    const resultOuterHtml = $(resultUrlSelector).prop("outerHTML");

    if (hrefResultObj.productIds.length > 0) {
      $(resultUrlSelector).replaceWith(
        resultOuterHtml.replaceAll("<span", "<a").replaceAll("</span>", "</a>")
      );
      $(resultUrlSelector).attr("disabled", false);

      $(resultUrlSelector).attr(
        "href",
        `?data=${encode(JSON.stringify(hrefResultObj))}`
      );
    } else {
      $(resultUrlSelector).replaceWith(
        resultOuterHtml.replaceAll("<a", "<span").replaceAll("</a>", "</span>")
      );
      $(resultUrlSelector).attr("disabled", true);
    }
  };

  const handlePriceCalculator = (selector, currentPrice) => {
    const href = $(selector).attr("href");
    const urlObject = new URL(href);
    urlObject.searchParams.set("price", currentPrice === 0 ? 75000 : currentPrice);
    $(selector).attr("href", urlObject.toString());
  };

   // check if current page is customizer 2
   let searchParams = new URLSearchParams(window.location.search);
   const isCustomizer2 = searchParams.has('customizer') && searchParams.get('customizer') === '2';

  const handleData = () => {
    const el = {
      form: "form.js-Customizer__Form",
      fieldOption: "form.js-Customizer__Form input, form textarea",
      customButtonTriger: ".js-toggle-class-slide",
      drawerResultCount: ".js-CuztomizerDrawer__Title__Result",
      drawerResultCountText: ".js-CuztomizerDrawer__Title__ResultText",
      resultUrl: ".js-CuztomizerDrawer__Buttons__Result",
      printPdfUrl: ".js-print-url",
      offerteUrl: ".js-offer-url",
      priceCalculator: ".js-price-calculator",
      buttonData: ".js-button-data",
      buttonRemoveFile: "form.js-Customizer__Form .js-remove-file",
      headerTotalPrice: ".js-header-total-price",
      saveWishList: ".js-save-wishlist",
    };

    if ($(el.form).length === 0) return;

    const popupPdf__dataItem =
      $(el.buttonData).data("item") ??
      JSON.parse($(`${el.buttonData}__input`).val());
      
    const productLists = $(el.form).data("product_lists");
    let productListsEliminate = productLists;
    const formValue = $(el.form).data("content_value");
    const formValueLocalStorage = JSON.parse(
      LocalStorage.get(localStorage.customizer)
    );

    const getTotalSumPrice = (storeData, subTaxonomy) => {
      const getBasePrice = $(el.headerTotalPrice).data("price_float");
      const sumPriceData = Object.values(storeData);
      let sumPrice = getBasePrice;
      for (let sp = 0; sp < sumPriceData.length; sp++) {
        const sumPriceDataAttr = sumPriceData[sp];
        if (sumPriceDataAttr[`${subTaxonomy}__price`]) {
          // sumPrice += sumPriceDataAttr[`${subTaxonomy}__price`];
          sumPrice += sumPriceDataAttr[`${subTaxonomy}__price`].reduce((acc, curr) => acc + curr, 0);// sum all of the value
        }
      }

      return sumPrice;
    };

    const handlePrice = (storeData, subTaxonomy) => {
      const sumPrice = getTotalSumPrice(storeData, subTaxonomy);

      ajaxGetWcPrice(sumPrice)
        .then((res) => {
          $(`${el.headerTotalPrice} > span`).html(res.data.price);
          return __popupData({
            dataPdf: popupPdf__dataItem,
            price: res.data.price,
            selectorStore: el.buttonData,
          });
        })
        .catch((err) => console.error(err));
    };

    const productEliminate = (productLists, storeData) => {
      
      if (!productLists) return [];
      const filterDataList = Object.entries(storeData);
      const filterDataReady = {};
      for (let i = 0; i < filterDataList.length; i++) {
        const filterData = filterDataList[i];
        
        if (filterData[0] !== "__expired__") {
          // eslint-disable-next-line no-unused-vars
          const [_, ...subKey] = filterData[0].split("-");
          const key   = subKey.join("-").replaceAll("_", "-")
          const value = filterData[1]["customizer-option"];
          
          if (value) filterDataReady[key] = value;
        }
      }

      const combination = Object.entries(filterDataReady);

      const newPL = productLists.filter((data) => {
        return filterProduct(data, combination);
      });  

      
      return newPL;
    };

    const arraysContainSameElements = (arr1, arr2) => {
      if (arr1.length !== arr2.length) {
          return false;
      }
      
      // Sort both arrays
      arr1.sort();
      arr2.sort();
      
      // Compare elements
      for (let i = 0; i < arr1.length; i++) {
          if (parseInt(arr1[i]) !== parseInt(arr2[i])) {
              return false;
          }
      }
      
      return true;
    }

    const filterProduct = (data, combination) => {
      for (let i in combination) {
          const key = combination[i][0];
          const val = combination[i][1];

            // console.log(data.terms[key],key,  val);
            // if(key === 'kleur') return true;
            if(key === 'opties' && val.length > 1){
              //check the opties array
              if (!arraysContainSameElements(data.terms[key], val)){
                return false;
              }
            } else if (val.length > 0 && !data.terms[key]?.includes(parseInt(val))) {
                return false;
            }
            
      }

      return true;
    };

    const handleExpired = (taxArgs) => {
      const __expired__ = new Date().getTime() + 1 * 60 * 60 * 1000;
      if (taxArgs.__expired__) {
        const timeNow = new Date().getTime();

        if (timeNow > taxArgs.__expired__) {
          LocalStorage.delete(localStorage.customizer);
          taxArgs = {};
          taxArgs.__expired__ = __expired__;
        }
      } else {
        taxArgs.__expired__ = __expired__;
      }
    };

    const handleInput = (thisEl, storeData) => {
      const name            = thisEl.attr("name");
      let value             = thisEl.val();
      const taxonomy        = name.split("__")[0];
      const subTaxonomy     = name.split("__")[1];
      const targetImgChange = ".js-img-section-customizer"; //`.js-img-section-customizer--${taxonomy}`;
      let   img             = thisEl.data("image");
      let   model_id        = 0;

      if(typeof img == 'object'){
        $('input[type="checkbox"][id^="models-models-"]:checked').each(function() {
            model_id = $(this).val();
        });
        
        for (let i in img){
          if(parseInt(img[i].ka_model_id) === parseInt(model_id)){
            img = img[i].ka_image_model_color;
            break;
          }
        }
      }

      if (!storeData[taxonomy]) {
        storeData[taxonomy] = {};
      }

      if (thisEl.attr("rows")) {
        storeData[taxonomy]["customizer-option"] = null;

        $(`#section-customizer--${taxonomy}`)
          .find("input[type='checkbox']")
          .prop("checked", false);
        __popupData({
          data: {
            title: thisEl.data("title"),
            price: thisEl.data("price"),
          },
          dataPdf: popupPdf__dataItem,
          taxonomy: taxonomy,
          selectorStore: el.buttonData,
          customize: thisEl.attr("rows")
            ? {
              message: thisEl.val(),
            }
            : null,
        });
        storeData[taxonomy][subTaxonomy] = value;
      } else if (subTaxonomy === "request-file") {
        value = thisEl.prop("files");
        const isFileLessThan1MB = (value[0].size / 1024 / 1024).toFixed(4) <= 1;

        if (!isFileLessThan1MB) {
          alert(thisEl.data("message_too_big"));
          return storeData;
        }

        __popupData({
          data: {
            title: thisEl.data("title"),
            price: thisEl.data("price"),
          },
          dataPdf: popupPdf__dataItem,
          taxonomy: taxonomy,
          selectorStore: el.buttonData,
          customize: {
            file: value.length > 0 ? URL.createObjectURL(value[0]) : null,
          },
        });

        if (value.length > 0) {
          const reader = new FileReader();
          reader.readAsDataURL(value[0]);
          reader.onload = function (result) {
            const newTaxArgsFile = storeData;
            newTaxArgsFile[taxonomy][subTaxonomy] = result.currentTarget.result;
            LocalStorage.set(
              localStorage.customizer,
              JSON.stringify(newTaxArgsFile)
            );

            __popupData({
              data: {
                title: thisEl.data("title"),
                price: thisEl.data("price"),
              },
              dataPdf: popupPdf__dataItem,
              taxonomy: taxonomy,
              selectorStore: el.buttonData,
              customize: {
                file: result.currentTarget.result,
              },
            });
          };
        }

        $(`#${thisEl.data("change_name")}`).text(value[0].name);
        $(`#${thisEl.data("change_name")}`).removeClass("HasValue");
        $(`button[data-id="${thisEl.data("change_name")}"]`).css(
          "display",
          "inline"
        );
        $(`#section-customizer--${taxonomy}`)
          .find("input[type='checkbox']")
          .prop("checked", false);
        storeData[taxonomy][subTaxonomy] = value;
      } else {
        const checkboxes = thisEl
          .parent()
          .parent()
          .find(`input[type='checkbox']`);
        const currentCheckbox = thisEl;
        
        // check if current page is customizer 2
        // check if current element is not opties and not in customizer 2 
        if(taxonomy !== 'opties-opties' && !isCustomizer2) checkboxes.not(currentCheckbox).prop("checked", false);

        const isChecked = currentCheckbox.prop("checked");

        // const getThisPriceEl = $.parseHTML(thisEl.data("price"))[0];
        // const getThisPriceFloat = JSON.parse(
        //   getThisPriceEl.getAttribute("data-price_float")
        // );
        
        let arrTitle = []
        let arrPrice = []

        const popupDataArgs = {
          data: {
            title: arrTitle,
            price: arrPrice,
          },
          dataPdf: popupPdf__dataItem,
          taxonomy: taxonomy,
          selectorStore: el.buttonData,
          customize: thisEl.attr("rows") ? {
            message: thisEl.val(),
          } : null,
        };
        //check all checked taxonomy (new)
        const elements = $(`[id^="${taxonomy}-"]`);
        if (!isChecked) {
          let temp = [];
          if(elements){
            if(taxonomy === 'models-models'){
              const otherCustomizer = $('.Customizer__Text__Content__Fields__Option:not([data-typeinput="models"])')
              otherCustomizer.each(function() {
                if($(this).find('input[type="checkbox"]').prop('checked')){
                  $(this).trigger('click')
                }
              })
              otherCustomizer.prop("checked", false);
            }
            elements.each(function() {
              if($(this).prop('checked') == true){
                temp.push($(this).val());
                arrTitle.push($(this).data("title"))
                arrPrice.push($(this).data("price"))
              }
            });
          }
          storeData[taxonomy][subTaxonomy] = temp;
          currentCheckbox.prop("checked", false);

          hideOtherCustomizer(taxonomy, storeData[taxonomy][subTaxonomy], 'section-customizer-models')

          __popupData({ ...popupDataArgs, isUnselect: true });
        } else {
          
          // Loop through the selected elements
          let temp = [];
          elements.each(function() {
            if($(this).prop('checked') == true){
              temp.push($(this).val());
              arrTitle.push($(this).data("title"))
              arrPrice.push($(this).data("price"))
            }
          });
          storeData[taxonomy][subTaxonomy] = temp;

          hideOtherCustomizer(taxonomy, storeData[taxonomy][subTaxonomy], 'section-customizer-models')

          __popupData(popupDataArgs);
          $(targetImgChange).attr("src", img);
        }
        

        // handle price per product
        // if (isChecked) {
          let tempPrice = [];
          elements.each(function() {
            const getThisPriceEl = $.parseHTML($(this).data("price"))[0];
            const getThisPriceFloat = JSON.parse(
              getThisPriceEl.getAttribute("data-price_float")
            );
            if($(this).prop('checked') == true){
              tempPrice.push(getThisPriceFloat);
            }
          });
          storeData[taxonomy][`${subTaxonomy}__price`] = tempPrice;
        // } else {
        //   storeData[taxonomy][`${subTaxonomy}__price`] = 0;
        // }
        
        handlePrice(storeData, subTaxonomy);
        const totalSumPrice = getTotalSumPrice(storeData, subTaxonomy);

        handlePriceCalculator(el.priceCalculator, totalSumPrice);
        productListsEliminate = productEliminate(productLists, storeData);

        if(taxonomy === 'models-models'){ //make hideattributefilter executed only when user click models
          hideAttributeFilter(productListsEliminate);
        }

        
      }

      $(el.drawerResultCount).html(productListsEliminate.length);
      if ( productListsEliminate.length === 0 || productListsEliminate.length === 1) {
        $(el.drawerResultCountText).text("auto");
      } else {
        $(el.drawerResultCountText).text("auto's");
      }

      handleButtonResult(productListsEliminate, el.resultUrl, storeData);
      handleSendPostData(el.printPdfUrl);
      handleSendPostData(el.offerteUrl);

      return storeData;
    };

    const removeDuplicateValArr = (array) => {
      return array.reduce((accumulator, currentValue) => {
        if (currentValue !== null && !accumulator.includes(currentValue)) {
            accumulator.push(currentValue);
        }
        return accumulator;
      }, []);
    }

    const hideAttributeFilter = (data) => {
      let searchParams = new URLSearchParams(window.location.search) 
      if(!searchParams.has('customizer') && searchParams.get('customizer') != 2){
        let modelsChecked = $('[id^="models-"]:checked').length;
        let otherInputsChecked = false;

        $('.js-all-input').each(function() {
          const termid = $(this).data('termid');
          const typeinput = $(this).data('typeinput');
          const shouldShow = data.some(product => product.terms[typeinput] && product.terms[typeinput].includes(termid));

          shouldShow ? $(this).show() : $(this).hide();

          if($(this).find('input[type="checkbox"]').is(':checked')) {
            $(this).show();

            const typeinput = $(this).closest('label').data('typeinput');
            if (typeinput !== 'models') {
              otherInputsChecked = true;
            }
          }
        });

        // to check if there is models checked and other option are not checked
        if(modelsChecked > 0 && !otherInputsChecked){
          const dataByModels = {kleur : []}
          data.forEach(d => dataByModels.kleur.push(d.terms?.kleur?.[0]))

          const dataByModelsFiltered = removeDuplicateValArr(dataByModels.kleur);
          dataByModels.kleur = dataByModelsFiltered

          LocalStorage.set(localStorage.optionsByModels, dataByModels);
        }
        else { // if other input checked or not checked
          if(modelsChecked === 0) LocalStorage.delete(localStorage.optionsByModels)
          if(LocalStorage.get(localStorage.optionsByModels)){
            const optionsByModels = LocalStorage.get(localStorage.optionsByModels)
            
            // show all kleur that included in the optionsByModels
            $('.js-all-input[data-typeinput="kleur"]').each(function () {
              const termid = $(this).data('termid');
              optionsByModels.kleur.includes(termid) ? $(this).show() : $(this).hide();
            })
          }
        }

        // let countModel  = $('[id^="models-"]:checked').length;
        // let countKleur  = $('[id^="kleur-"]:checked').length;

        // if(countModel === 0) $('.js-all-input[data-typeinput="models"]').show()
        // if(countKleur === 0) $('.js-all-input[data-typeinput="kleur"]').show()
        $('.js-all-input[data-typeinput="opties"]').show()
      }
    };

    

    /* 
    Hide sections other than 'alwaysShowKey' when 'alwaysShowKey' not 
    models-models that have id 'idSection' when the 'keyVal' in 'idSection' does not exist.  
    */
    const hideOtherCustomizer = (alwaysShowKey, keyVal, idSection) => { 
      if(!isCustomizer2 && alwaysShowKey === 'models-models'){
        if(keyVal.length === 0){
          // console.log(alwaysShowKey, alwaysShowKey === 'models-models', keyVal.length)
          $(`.CustomizerChildSection:not(#${idSection})`).hide()
          $(`.CustomizerHeader__SectionLink:not(.CustomizerHeader__SectionLink[href='#${idSection}'])`).hide()
          $(`.js-show-warning`).show()
        }else{
          // console.log(alwaysShowKey, keyVal.length)
          $(`.CustomizerChildSection:not(#${idSection})`).show()
          $(`.CustomizerHeader__SectionLink:not(.CustomizerHeader__SectionLink[href='#${idSection}'])`).show()
          $(`.js-show-warning`).hide()
        }
      }
    }

    const taxArgs = formValue ? formValue : (formValueLocalStorage ? formValueLocalStorage: {});

    $(window).on("load", function () {
      const lists = Object.entries(taxArgs);
      if(lists.length <= 1 ){
        hideOtherCustomizer('models-models', [], 'section-customizer-models') //force to get into first conditon inside function
      }

      if (formValue) {
        LocalStorage.set(localStorage.customizer, JSON.stringify(formValue));
      }
      handleExpired(taxArgs);

      let totalSumPrice = getTotalSumPrice(taxArgs, '');
      for (let i = 0; i < lists.length; i++) {
        const key = lists[i][0];
        const value = lists[i][1];
        
        const listValue = Object.entries(value);
        const keyLastName = key.replace(key.split("-").shift() + "-", "");
        
        for (let j = 0; j < listValue.length; j++) {
          const subKey = listValue[j][0];
          const subValue = listValue[j][1];

          if (subKey === "customizer-option") {
            if(subValue.length > 0){ // check if value is exist
              if(subValue.length > 1){ // check if value more than 1 which identified as an array
                subValue.forEach(val => {
                  $(`input[name="${key}__${subKey}"][value="${val}"]`).prop("checked", true);
                });
              }else{
                $(`input[name="${key}__${subKey}"][value="${subValue}"]`).prop( "checked",true);
              }
            }

            hideOtherCustomizer(key, subValue, 'section-customizer-models')
            handlePrice(taxArgs, subKey);
            totalSumPrice = getTotalSumPrice(taxArgs, subKey);
            
            if (value["customizer-option"]) {
              let arrTitle = []
              let arrPrice = []
              
              const popupDataArgs = {
                data: {
                  title: arrTitle,
                  price: arrPrice,
                },
                dataPdf: popupPdf__dataItem,
                taxonomy: key,
                selectorStore: el.buttonData,
              };
              
              value["customizer-option"].forEach(valCO => {
                arrTitle.push($(`#${key}-${valCO}__customizer-option`).data("title"))
                arrPrice.push($(`#${key}-${valCO}__customizer-option`).data("price"))
              });

              // __popupData({
              //   data: {
              //     title: $(`#${key}-${value["customizer-option"]}__customizer-option`).data("title"),
              //     price: $(`#${key}-${value["customizer-option"]}__customizer-option`).data("price"),
              //   },
              //   dataPdf: popupPdf__dataItem,
              //   taxonomy: key,
              //   selectorStore: el.buttonData,
              // });

              __popupData(popupDataArgs);
            }
          } else if (subKey === "request-description" && subValue) {
            $(`textarea[name="${key}__${subKey}"]`).val(subValue);
            $(`#request-form-${keyLastName}`).css("display", "block");
            $(`[data-show_if="custom_hide"]`).css("display", "none");
            $(`[data-show_if="custom_show"]`).css("display", "block");
            $(`.js-CustomizerSection`).addClass(
              "CustomizerSection--FullHeight"
            );

            __popupData({
              data: {
                title: $(`#${key}__${subKey}`).data("title"),
                price: "",
              },
              dataPdf: popupPdf__dataItem,
              taxonomy: key,
              selectorStore: el.buttonData,
              customize: {
                message: subValue,
              },
            });
          } else if (subKey === "request-file" && subValue) {
            $(`#request-form-${keyLastName}`).css("display", "block");
            $(`[data-show_if="custom_hide"]`).css("display", "none");
            $(`[data-show_if="custom_show"]`).css("display", "block");
            $(`.js-CustomizerSection`).addClass(
              "CustomizerSection--FullHeight"
            );
            $(`#${key}__${subKey}`)
              .parent()
              .siblings("span")
              .addClass("HasValue");
            $(`#${key}__${subKey}`)
              .parent()
              .siblings("button")
              .css("display", "inline");

            __popupData({
              data: {
                title: $(`#${key}__${subKey}`).data("title"),
                price: "",
              },
              dataPdf: popupPdf__dataItem,
              taxonomy: key,
              selectorStore: el.buttonData,
              customize: {
                file: subValue,
              },
            });
          }
        }
      }

      productListsEliminate = productEliminate(productLists, taxArgs);
      
      hideAttributeFilter(productListsEliminate);

      $(el.drawerResultCount).html(productListsEliminate.length);
      if (
        productListsEliminate.length === 0 ||
        productListsEliminate.length === 1
      ) {
        $(el.drawerResultCountText).text("auto");
      } else {
        $(el.drawerResultCountText).text("auto's");
      }

      handleButtonResult(productListsEliminate, el.resultUrl, taxArgs);
      handleSendPostData(el.printPdfUrl);
      handleSendPostData(el.offerteUrl);
      ajaxSaveWishlist(el.saveWishList);
      handlePriceCalculator(el.priceCalculator, totalSumPrice);
      __listProductsCustomizer2(taxArgs);
      LocalStorage.set(localStorage.customizer, JSON.stringify(taxArgs));

      // keep the selected image after reload
      const targetImgChange = ".js-img-section-customizer";
      if (LocalStorage.get(localStorage.customizer)) {
        const getLocalStorageData = JSON.parse(LocalStorage.get(localStorage.customizer));
        const keyName = Object.keys(getLocalStorageData)[0] == '__expired__' ? Object.keys(getLocalStorageData)[1] : Object.keys(getLocalStorageData)[0]; //get options without select __expired__
        const optionID = getLocalStorageData[keyName]['customizer-option']
        const imageURL = $(`#${keyName}-${optionID}__customizer-option`).data('image')

        $(targetImgChange).attr("src", imageURL);
      }
    });

    $(document).on("input", el.fieldOption, function () {
      const newTaxArgs = handleInput($(this), taxArgs);
      __listProductsCustomizer2(taxArgs);
      handleExpired(taxArgs);
      $(el.saveWishList).removeClass("saved");

      LocalStorage.set(localStorage.customizer, JSON.stringify(newTaxArgs));
    });

    $(document).on("click", el.customButtonTriger, function () {
      const dataFor = $(this).data("for");
      const elFors = [`${dataFor} input`, `${dataFor} textarea`];

      elFors.forEach((elFor) => {
        const name = $(elFor).attr("name");
        const taxonomy = name.split("__")[0];
        const subTaxonomy = name.split("__")[1];

        if (!taxArgs[taxonomy]) {
          taxArgs[taxonomy] = {};
        }

        __popupData({
          data: {
            title: $(elFor).data("title"),
            price: $(elFor).data("price"),
          },
          dataPdf: popupPdf__dataItem,
          taxonomy: taxonomy,
          selectorStore: el.buttonData,
          customize: false,
        });

        taxArgs[taxonomy][subTaxonomy] = null;
      });

      __listProductsCustomizer2(taxArgs);
      LocalStorage.set(localStorage.customizer, JSON.stringify(taxArgs));
    });

    $(document).on("click", el.buttonRemoveFile, function (e) {
      e.preventDefault();
      const dataKey = $(this).data("key");
      const dataTextEl = $(this).data("id");

      const [taxonomy, subTaxonomy] = dataKey.split("__");

      __popupData({
        data: {
          title: $(this).data("title"),
          price: $(this).data("price"),
        },
        dataPdf: popupPdf__dataItem,
        taxonomy: taxonomy,
        selectorStore: el.buttonData,
        customize: false,
      });

      taxArgs[taxonomy][subTaxonomy] = null;
      $(`#${dataKey}`).val("");
      $(`#${dataTextEl}`).text("");
      $(`#${dataTextEl}`).removeClass("HasValue");
      $(this).css("display", "none");
      LocalStorage.set(localStorage.customizer, JSON.stringify(taxArgs));
    });
  };

  init();
};

try {
  formRequest();
} catch (error) {
  console.error("formRequestCustomizer", error);
}
